/**
 * Organization: Revzoom India Pvt Ltd.
 * User: om
 * Date: 16/01/17
 * Time: 9:43 PM
 */
export default class HttpOperationPayload {

  constructor(data, onSuccess, onFailure) {
    /**
     * @private
     * @type {*}
     * @const
     */
    this._data = data;
    /**
     * @private
     * @type Function
     * @const
     */
    this._onSuccess = onSuccess;
    /**
     * @private
     * @type Function
     * @const
     */
    this._onFailure = onFailure;
  }

  /**
   * @return {*}
   */
  get data() {
    return this._data;
  }

  /**
   * @return {Function}
   */
  get onSuccess() {
    return this._onSuccess;
  }

  /**
   * @return {Function}
   */
  get onFailure() {
    return this._onFailure;
  }
}